/**
 * "Offline 43s", ticking. SPEC.md §16.5, §8.5.
 *
 * The seat, the host's player sheet and the reconnect overlay all say the same
 * thing about the same clock, so they say it with the same component. Mounted only
 * while something is actually offline — that is what keeps the shared 1 Hz timer
 * stopped on a healthy table. §44
 */

import { formatOfflineFor } from '@card-counter/shared';
import { useSecondsSince } from '@/hooks/useSecondsSince';

export interface OfflineForProps {
  /** ISO `lastSeenAt` for another player, epoch ms for this device. */
  since: string | number;
  className?: string;
}

export function OfflineFor({ since, className }: OfflineForProps) {
  const seconds = useSecondsSince(since);
  return (
    <span data-numeric className={className}>
      {formatOfflineFor(seconds)}
    </span>
  );
}
